<template>
  <div class="page-container">
    <TableList
      style="min-height: 80vh"
      :columns="tabPaneConfig[0].columns"
      :tableData="tabPaneConfig[0].tableData"
      :loading="tabPaneConfig[0].loading"
      :scroll="{}"
      :pagination="tabPaneConfig[0].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            :isShowEmpty="false"
            @select="$set(queryParam, 'classId', undefined)"
          />
          <j-dict-select-tag
            style="width: 170px; margin-right: 15px"
            placeholder="请选择班级"
            v-model="queryParam.classId"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :async="true"
            :disabled="!queryParam.gradeId"
            :isShowEmpty="false"
          />
          <a-range-picker v-model="dateRange" class="search-space" style="width: 240px" />
          <j-dict-select-tag
            v-model="queryParam.careList"
            placeholder="关爱等级"
            dictCode="care_list"
            class="search-space"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>
        <a-button
          type="primary"
          icon="download"
          style="margin-left: auto"
          @click="handleExportXls('重点关爱学生干预情况统计')"
        >
          导出
        </a-button>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="commentClick(record)">点评</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
        </div>
      </template>
    </TableList>
    <CommentModal ref="commentModalRef" @refreshData="loadData" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import CommentModal from './components/CommentModal'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'PriorityCareStu',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    CommentModal,
  },
  data() {
    return {
      tabKey: 1,
      currPage: 1,
      queryParam: {},
      tabPaneConfig: [
        {
          tab: '学生咨询',
          key: 1,
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'studentClass',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'name',
              align: 'center',
            },
            {
              title: '关爱等级',
              dataIndex: 'careList_dictText',
              align: 'center',
            },
            {
              title: '最近沟通时间',
              dataIndex: 'maxTutorTime',
              align: 'center',
              customRender: (_, record) => {
                return record.maxTutorTime || '-'
              },
            },
            {
              title: '辅导次数',
              dataIndex: 'tutorNum',
              align: 'center',
              customRender: (_, record) => {
                return record.tutorNum || 0
              },
            },
            {
              title: '家长电话',
              dataIndex: 'phone',
              align: 'center',
              customRender: (_, record) => {
                return record.phone.length >= 25 ? (
                  <a-tooltip>
                    <template slot="title">{record.phone}</template>
                    {record.phone.substring(0, 25) + '...'}
                  </a-tooltip>
                ) : (
                  record.phone
                )
              },
            },
            {
              title: '辅导方法',
              dataIndex: 'tutoringType',
              align: 'center',
              customRender: (_, record) => {
                const res = getDictCodeData('tutoring_type', record.tutoringType)
                return res.text
              },
            },
            {
              title: '问题原因',
              dataIndex: 'tagId',
              align: 'center',
              customRender: (_, record) => {
                const res = getDictCodeData('emotional_type', record.tagId)
                return res.text
              },
            },
            {
              title: '干预措施',
              dataIndex: 'interventionId',
              align: 'center',
              customRender: (_, record) => {
                const res = getDictCodeData('intervention', record.interventionId)
                return res.text
              },
            },
            {
              title: '效果反馈',
              dataIndex: 'effectFeedback',
              align: 'center',
              customRender: (_, record) => {
                const res = getDictCodeData('effect_feedback', record.effectFeedback)
                return res.text
              },
            },
            {
              title: '具体情况说明',
              dataIndex: 'comment',
              align: 'center',
              customRender: (_, record) => {
                return record.comment.length >= 25 ? (
                  <a-tooltip>
                    <template slot="title">{record.comment}</template>
                    {record.comment.substring(0, 25) + '...'}
                  </a-tooltip>
                ) : (
                  record.comment
                )
              },
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/aigoes/schoolWarnRecord/getCrisisInterventionList',
        exportXlsUrl: '/aigoes/schoolWarnRecord/crisisInterventionExport',
      },
      warnCategoryOpts: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '重点关爱学生',
          value: 1,
        },
        {
          label: '提醒学生',
          value: 2,
        },
      ],
      warnLvOpts: [
        {
          label: '正常',
          value: 0,
        },
        {
          label: '一级',
          value: 1,
        },
        {
          label: '二级',
          value: 2,
        },
        {
          label: '三级',
          value: 3,
        },
      ],
      assessStatusOpts: [
        {
          label: '已评估',
          value: 0,
        },
        {
          label: '未评估',
          value: 1,
        },
      ],
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      console.log('搜索条件--', event.target.value)
      const name = event.target.value
      this.getTableData({
        name,
      })
    }, 500),
    loadData() {
      let params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
      }
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/aigoes/schoolWarnRecord/getCrisisInterventionList')
          params = { ...params }
          break
      }
      this.getTableData(params)
    },
    getTableData(params) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    commentClick(record) {
      this.$refs.commentModalRef.showModal(record)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.page-container {
  .query-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .action-detail {
    min-width: 100px !important;
    color: #0077fa !important;
    cursor: pointer !important;
  }
  .search-space {
    width: 140px;
    margin-right: 15px;
  }
}
</style>
